module.exports = __webpack_public_path__ + "static/media/Terracottocat_Single.4afb7479.png";